export default {
  daysLeft: {
    id: 'eligible_insurance_card_eligibility_end_days_left',
    defaultMessage: '{daysLeft} days left to get protected.',
  },
  hoursLeft: {
    id: 'eligible_insurance_card_eligibility_end_hours_left',
    defaultMessage:
      '{hoursLeft, plural, one {# hour} other {# hours}} left to get protected.',
  },
  startingPrice: {
    id: 'eligible_insurance_card_starting_price',
    defaultMessage: 'Starting from {price}',
  },
}
